import DSTabGradientViewPaper from '../../../design-system/Paper/DSTabGradientViewPaper';
import { useTheme, Box } from '@mui/material';
import { ReactComponent as AtWorkIcon } from '../../../design-system/Icons/atWork.svg';
import { DSTypography } from '../../../design-system/Typography';
import { KLYDO_WHITE, KLYDO_YELLOW } from '../../../consts/colors';
import { SUPPORT_EMAIL } from '../../../consts/alerts';
import DSBox from '../../../design-system/DSBox';

const Collections = () => {
  const { spacing } = useTheme();
  return (
    <DSTabGradientViewPaper
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        margin: { xxs: spacing(0), xl: spacing(3) },
        maxHeight: '87vh',
        minHeight: '87vh',
        padding: spacing(4),
      }}
    >
      <AtWorkIcon />

      <Box
        sx={{
          maxWidth: { xxs: '90%', md: '40%' },
          textAlign: 'left',
          display: 'flex',
          flexDirection: 'column',
          gap: spacing(3),
        }}
      >
        <DSTypography
          fontFamily="Gilroy-Black"
          color={KLYDO_YELLOW}
          fontSize={{ xxs: '30px', md: '64px', xl: '80px' }}
          sx={{ textAlign: 'center' }}
        >
          Coming Soon!
        </DSTypography>

        <DSTypography
          fontFamily="Gilroy-Regular"
          color={KLYDO_WHITE}
          fontSize={{ xxs: '16px', md: '18px', xl: '20px' }}
          sx={{ gap: spacing(3), display: 'flex', flexDirection: 'column' }}
        >
          <DSBox>
            We're taking Klydo content to the next level, with new ways to
            create and earn
          </DSBox>
          <DSBox>
            Be part of the first wave of artists inside Klydo's next chapter,
            including fresh formats, bold ideas, and personalized experiences at
            the edge of innovation.
          </DSBox>
          <DSBox>
            <Box component="span" sx={{ fontFamily: 'Gilroy-Bold' }}>
              And yes, there's more:
            </Box>{' '}
            revenue sharing, new ways to get paid, and exclusive opportunities
            as we grow together.
          </DSBox>
        </DSTypography>

        <Box sx={{ textAlign: 'center' }}>
          <DSTypography
            fontFamily="Gilroy-Medium"
            color={KLYDO_YELLOW}
            fontSize={{ xxs: '16px', md: '18px', xl: '20px' }}
            lineHeight={'120%'}
            sx={{
              display: 'inline-block',
              borderBottom: `1px solid ${KLYDO_YELLOW}`,
              cursor: 'pointer',
            }}
            onClick={() => (window.location.href = `mailto:${SUPPORT_EMAIL}`)}
          >
            Be part of it - artists@klydoclock.com
          </DSTypography>
        </Box>
      </Box>
    </DSTabGradientViewPaper>
  );
};

export default Collections;
